import { render, staticRenderFns } from "./CoordinatorAdd.vue?vue&type=template&id=d2194950&"
import script from "./CoordinatorAdd.vue?vue&type=script&lang=js&"
export * from "./CoordinatorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports